import React from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[color:var(--brand-cream)] text-[color:var(--brand-ink)]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster richColors position="top-right" />
    </div>
  );
}
